module.exports = __webpack_public_path__ + "img/aq4@2x.f8888462.png";